import { render, staticRenderFns } from "./BaseCosts.vue?vue&type=template&id=43605f3e&"
import script from "./BaseCosts.vue?vue&type=script&lang=js&"
export * from "./BaseCosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports